import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from './stores/auth'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/login', component: () => import('./views/LoginView.vue'), meta: { public: true, hideNav: true } },
    { path: '/', component: () => import('./views/HomeView.vue') },
    { path: '/result/:orderNo', component: () => import('./views/ResultView.vue'), meta: { hideNav: true } },
    { path: '/warehouse', component: () => import('./views/WarehouseView.vue') },
    { path: '/store', component: () => import('./views/StoreView.vue') },
    { path: '/orders', component: () => import('./views/OrdersView.vue') },
    { path: '/profile', component: () => import('./views/ProfileView.vue') }
  ],
  scrollBehavior: () => ({ top: 0 })
})

router.beforeEach((to) => {
  const auth = useAuthStore()
  if (!to.meta.public && !auth.authenticated) return { path: '/login', query: { redirect: to.fullPath } }
  if (to.path === '/login' && auth.authenticated) return '/'
})

router.afterEach(() => requestAnimationFrame(() => document.querySelector<HTMLElement>('#main-content')?.focus()))
export default router

